<template>
  <div class="progress-bar">
    <img
      v-if="imageSource"
      :src="imageSource"
      class="progress-image"
    />
    <div
      v-if="displayBack"
      class="progress--back"
      @click.prevent="stepBack">
      ← {{ $t('generic.back_last_question') }}
    </div>
    <div
      class="progress--close"
      @click.prevent="$emit('quit')">
      <icon src="/product-advisor/images/icons/close.svg" />
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'imageSource',
      'displayBack',
    ],
    methods: {
      stepBack() {
        this.$store.commit('decrementLevel')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .progress-bar {
    @apply
      h-15
      w-full
      relative
      rounded-t
      bg-ctm-tertiary;

    .progress-image {
      @apply
        w-full
        object-contain
        bottom-0
        absolute
        max-h-14
        max-w-full;
    }

    .progress--back {
      @apply
        top-2
        left-2
        text-xs
        absolute
        cursor-pointer
        text-ctm-primary;
    }

    .progress--close {
      @apply
        h-6
        w-6
        flex
        top-0
        right-0
        bg-white
        absolute
        sm:hidden
        items-center
        justify-center
        text-ctm-primary;
    }
  }
</style>